import { render, staticRenderFns } from "./ResumoNascimento.vue?vue&type=template&id=5b200e0c&"
import script from "./ResumoNascimento.vue?vue&type=script&lang=js&"
export * from "./ResumoNascimento.vue?vue&type=script&lang=js&"
import style0 from "./ResumoNascimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports